"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeSentioQuery = executeSentioQuery;
async function executeSentioQuery(sql) {
    const url = "https://api.sentio.xyz/v1/analytics/dave/alphalend/sql/execute";
    const method = "POST";
    const headers = {
        "api-key": "nxI3D3bcx0JuvA5P5SsUHYfjWKDSc4JLR",
    };
    const query = {
        sqlQuery: {
            sql,
        },
    };
    const response = await fetch(url, {
        method,
        headers: {
            "Content-Type": "application/json",
            ...headers,
        },
        body: JSON.stringify(query),
    });
    if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
    }
    const sentioResponse = (await response.json());
    return sentioResponse.result.rows;
}
//# sourceMappingURL=sentioClient.js.map